// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/font/nasalization-rg.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/SchoolBundle/India/sb-carousel-a-meritus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../public/images/SchoolBundle/India/sb-carousel-b-meritus.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../public/images/SchoolBundle/India/sb-carousel-c-meritus.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "NasalizationRg";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.sb-carousel-item {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  height: 460px;
  position: relative;
}

.sb-carousel-item-a {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.sb-carousel-item-b {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.sb-carousel-item-c {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.sbc-heading h2 {
  font-family: "NasalizationRg", sans-serif;
  font-size: 65px;
  color: #fff;
  margin-bottom: 0;
}

.sbc-subhead h3,
.sbc-subhead p {
  color: #fff;
  font-size: 30px;
  margin-bottom: 0;
}

.sb-carousel-item-inner-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.sbc-para {
  margin-top: 25%;
}

.sbc-para p {
  color: #fff;
  font-weight: 600;
}

.sbc-3-para {
  font-size: 50px !important;
}

.sb-carousel .owl-dots {
  position: absolute;
  top: 95%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.sb-carousel .owl-dots .owl-dot.active span,
.sb-carousel .owl-dots .owl-dot:hover span {
  background: #2a8dfa;
  border: 2px solid #fff;
}

.sb-carousel .owl-dots .owl-dot span {
  background: #fff;
}

@media (max-width: 1024px) {
  .sb-carousel .owl-dots {
    top: 85%;
    margin-top: 0px;
  }
  .sbc-para {
    margin-top: 0%;
  }

  .sb-carousel-item {
    height: 360px;
  }
}

@media (max-width: 576px) {
  .sbc-subhead h3,
  .sbc-subhead p {
    font-size: 16px !important;
    line-height: 1;
    font-weight: 400;
  }

  .sbc-3-para {
    font-size: 16px !important;
    font-weight: 300;
  }

  .sb-carousel-item {
    height: 180px;
  }

  .sb-carousel-item-inner-content {
    width: 100%;
  }

  .sbc-heading {
    padding-top: 10px;
  }

  .sbc-heading h2 {
    font-size: 30px;
    font-weight: 500;
  }

  .sbc-para p {
    font-weight: 300;
  }

  .sb-carousel .owl-dots .owl-dot span {
    height: 5px;
    width: 5px;
  }

  .sb-carousel .owl-dots {
    margin-top: 0 !important;
    margin-top: initial !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/common/sb-carousel/SchoolBundleCarousel.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,4CAAuD;AACzD;;AAEA;EACE,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yDAA+F;AACjG;;AAEA;EACE,yDAA+F;AACjG;;AAEA;EACE,yDAA+F;AACjG;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,QAAQ;IACR,eAAe;EACjB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,0BAA0B;IAC1B,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,wBAA4B;IAA5B,8BAA4B;EAC9B;AACF","sourcesContent":["@font-face {\n  font-family: \"NasalizationRg\";\n  src: url(\"../../../../public/font/nasalization-rg.otf\");\n}\n\n.sb-carousel-item {\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  height: 460px;\n  position: relative;\n}\n\n.sb-carousel-item-a {\n  background-image: url(\"../../../../public/images/SchoolBundle/India/sb-carousel-a-meritus.png\");\n}\n\n.sb-carousel-item-b {\n  background-image: url(\"../../../../public/images/SchoolBundle/India/sb-carousel-b-meritus.png\");\n}\n\n.sb-carousel-item-c {\n  background-image: url(\"../../../../public/images/SchoolBundle/India/sb-carousel-c-meritus.png\");\n}\n\n.sbc-heading h2 {\n  font-family: \"NasalizationRg\", sans-serif;\n  font-size: 65px;\n  color: #fff;\n  margin-bottom: 0;\n}\n\n.sbc-subhead h3,\n.sbc-subhead p {\n  color: #fff;\n  font-size: 30px;\n  margin-bottom: 0;\n}\n\n.sb-carousel-item-inner-content {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.sbc-para {\n  margin-top: 25%;\n}\n\n.sbc-para p {\n  color: #fff;\n  font-weight: 600;\n}\n\n.sbc-3-para {\n  font-size: 50px !important;\n}\n\n.sb-carousel .owl-dots {\n  position: absolute;\n  top: 95%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.sb-carousel .owl-dots .owl-dot.active span,\n.sb-carousel .owl-dots .owl-dot:hover span {\n  background: #2a8dfa;\n  border: 2px solid #fff;\n}\n\n.sb-carousel .owl-dots .owl-dot span {\n  background: #fff;\n}\n\n@media (max-width: 1024px) {\n  .sb-carousel .owl-dots {\n    top: 85%;\n    margin-top: 0px;\n  }\n  .sbc-para {\n    margin-top: 0%;\n  }\n\n  .sb-carousel-item {\n    height: 360px;\n  }\n}\n\n@media (max-width: 576px) {\n  .sbc-subhead h3,\n  .sbc-subhead p {\n    font-size: 16px !important;\n    line-height: 1;\n    font-weight: 400;\n  }\n\n  .sbc-3-para {\n    font-size: 16px !important;\n    font-weight: 300;\n  }\n\n  .sb-carousel-item {\n    height: 180px;\n  }\n\n  .sb-carousel-item-inner-content {\n    width: 100%;\n  }\n\n  .sbc-heading {\n    padding-top: 10px;\n  }\n\n  .sbc-heading h2 {\n    font-size: 30px;\n    font-weight: 500;\n  }\n\n  .sbc-para p {\n    font-weight: 300;\n  }\n\n  .sb-carousel .owl-dots .owl-dot span {\n    height: 5px;\n    width: 5px;\n  }\n\n  .sb-carousel .owl-dots {\n    margin-top: unset !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
